/**
 * Kürzen von mehrzeiligem Content
 *
 * Das dotdotdot Script kürzt in einem bestimmten Selector den Inhalt eines oder mehrerer Elemente und fügt bei Bedarf
 * einen Link zum weiterlesen und kürzen am Ende vom gekürztem Inhalt hinzu. Ist in diesem Element ein Button (a.btn) vorhanden,
 * wird dieser ausgelagert und unter den Inhalt gesetzt und weiterhin ausgegeben.
 *
 * @param {string} selector - jQuery Selector für den dotdotdot Container
 * @param {string} linkMore - Link zum weiterlesen des Inhalts
 * @param {string} linkLess - Link um erweiterten inhalte wieder zu kürzen
 * @param {(null|undefined|int)} height - Automatische Berechnung der Höhe, wenn der Default Wert null zutreffend ist.
 *
 * Events: window.load
 *
 * @return {undefined}
 */
function nc_initDotdotdot(selector, linkMore, linkLess, height) {
    var moduleLogger = LoggerManager.get('dotdotdot').setPrefix('Selektor: ' + selector);
    moduleLogger.trace('INIT START; linkMore: ' + linkMore + '; linkLess: ' + linkLess + '; height: ' + height);

    if ((typeof height === 'undefined' || height === null)) {
        moduleLogger.info('Höhe muss berechnet werden.');
        // Alle Elemente des Selektors durchgehen (Mehrere Bausteine - jeden für sich behandeln)
        if ($(selector).length) {
            moduleLogger.info($(selector).length + ' Elemente gefunden.', $(selector));
            $(selector).each(function () {
                var thisElement = this;

                // Element prüfen, ob es Bilder enthält - Hinweis: man kann die Abfrage auch mit ! umgekehren und
                // nicht === 0 abfragen.

                if ($(thisElement).find('img').length === 0) {
                    moduleLogger.info('Keine Bilder gefunden.', thisElement);
                    // Es wurde kein Bild gefunden -> Script starten für das Element
                    $(document).ready(function () {
                        nc_dotdotdot(thisElement, linkMore, linkLess, height);
                    });
                } else { // Bilder gefunden
                    moduleLogger.info($(thisElement).find('img').length + ' Bilder gefunden.', thisElement);
                    // Lazy Load aktiv?
                    moduleLogger.info('Kein Lazy Load aktiv', thisElement);
                    // Lazy Load nicht aktiv
                    $(window).load(function () {
                        nc_dotdotdot(thisElement, linkMore, linkLess, height);
                    });
                }
            });
        } else {
            moduleLogger.info('Keine Elemente gefunden');
        }
    } else {
        // Feste Höhe -> sofort ausführen, es muss auf nichts gewartet werden
        moduleLogger.info('Feste Höhe');
        $(document).ready(function () {
            nc_dotdotdot(selector, linkMore, linkLess, height);
        });
    }
    moduleLogger.info('INIT ENDE');
}


/**
 * @see nc_initDotdotdot
 */
function nc_dotdotdot(selector, linkMore, linkLess, height) {
    var moduleLogger = LoggerManager.get('dotdotdot').setPrefix(((typeof selector === 'object') ? 'Element: #' + $(selector).attr('id') : 'Selektor: ' + selector));
    moduleLogger.trace('SCRIPT START; linkMore: ' + linkMore + '; linkLess: ' + linkLess + '; height: ' + height);


    // Läd alle masonry Elemente neu, wenn es welche gibt.
    var reloadMasonry = function (selector) {
        moduleLogger.info('Masonry Elemente neuladen');
        $(selector).find('.ms-container').each(function () {
            var masonry = Masonry.data(this);
            if (masonry !== null) {
                masonry.layout();
            }
        })
    };

    $(selector).each(function () {
        var element = $(this).find('.module-content-block');
        if (typeof height === 'undefined') {
            height = null;
        }
        var maxHeight = height;
        if (maxHeight === null) {

            // Setzt die Höhe für das Element
            var heights = $(element).map(function () {
                return $(this).find('.thumbnail').outerHeight(true)
                    + $(this).find('.newsDate').outerHeight(true)
                    + $(this).find('.headline-wrapper').outerHeight(true);
            }).get();
            maxHeight = Math.max.apply(null, heights);

            // Hinzufügen und Entfernen eines Dummys zur Errechnung der line-height
            element.append('<span class="dummy-remove">&nbsp;</span>');
            var lineHeight = element.find('.dummy-remove').height();
            element.find('.dummy-remove').remove();

            maxHeight += lineHeight * 8;
        }

        moduleLogger.info('Script starten mit Höhe: ' + maxHeight);
        // Dotdotdot Script starten
        element.dotdotdot({
            height: maxHeight,
            keep: $('a.btn').parent('p'),
            ellipsis: '',
            callback: function (isTruncated) {
                if (!isTruncated) return false;

                // Nach der Ausführung Mehr anzeigen - Link hinzufügen
                $(this).find('div:not(.caption) > .text-wrapper:last-child > *:last-child').append(linkMore);

                reloadMasonry(selector);
            }
        });

        moduleLogger.info('Masonry Elemente ermitteln');


        // Mehr anzeigen - Link mit Funktion versehen
        element.on("click", '.readmore', function (e) {
            e.preventDefault();
            moduleLogger.info('Click readmore');
            $(e.delegateTarget).data("dotdotdot").restore();
            // Weniger anzeigen - Link am Ende hinzufügen
            $(e.delegateTarget).find('div:not(.caption) > .text-wrapper:last-child > *:last-child').append(linkLess);

            reloadMasonry(selector);
        });


        // Weniger anzeigen - Link mit Funktion versehen
        element.on("click", '.readless', function (e) {
            e.preventDefault();
            moduleLogger.info('Click readless');
            $(this).remove();
            $(e.delegateTarget).data("dotdotdot").truncate();
            $(e.delegateTarget).data("dotdotdot").watch();

            // Ist der untere Teil des Bausteins im Viewport?
            var moduleWrapper = $(e.delegateTarget).parents('.module-wrapper');
            var moduleWrapperTopPosition = moduleWrapper.offset().top;
            var moduleWrapperBottomPosition = moduleWrapperTopPosition + moduleWrapper.outerHeight(true);
            moduleLogger.info('Position Baustein Ende: ' + moduleWrapperBottomPosition + '; Position Scroll: ' + $(window).scrollTop());
            if ($(window).scrollTop() > moduleWrapperBottomPosition) {
                // Zum Baustein scrollen. Es wird 20% der ViewPort Höhe abgezogen, um den Baustein "mittiger"
                // zu platzieren. Das umgeht auch einige Probleme mit einem feststehenden Header.
                var scrollToPosition = moduleWrapperTopPosition - $(window).height() * 0.2;
                moduleLogger.info('Scroll zu Position: ' + scrollToPosition);
                $('html,body').animate({scrollTop: scrollToPosition}, 'fast');
            }
        });
    });

    reloadMasonry(selector);

    moduleLogger.info('SCRIPT ENDE');
}